import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';

import Link from '../../Link';
import getLocalizedContent from '../../../core/helpers/getLocalizedContent';

import searchIcon from '/public/SiteIcons/bookYourIcon.svg';
import steeingIcon from '/public/SiteIcons/download2.svg';

import s from './NewsBox.css';
import cs from '../../commonStyle.css';

class NewsBox extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      buttonLabel: PropTypes.string,
      image: PropTypes.string,
    }),
    locale: PropTypes.string,
  };

  render() {
    const { data, locale } = this.props;
    if (!data) {
      return null;
    }
    const { buttonLink1, buttonLink2 } = data;
    
    // Get localized content
    const title = getLocalizedContent(data, 'title', locale);
    const description = getLocalizedContent(data, 'description', locale);
    const buttonLabel = getLocalizedContent(data, 'buttonLabel', locale);
    const buttonLabel2 = getLocalizedContent(data, 'buttonLabel2', locale);

    return (
      <div className={s.bannerWrapper}>
        {/* Content Container - Premium stagger animations */}
        <div className={s.contentContainer}>
          {/* Title - Animated with shimmer */}
          <h1 className={cx(s.heroTitle, s.animateTitle)}>
            {title || "¡Sube y NAVEGA!"}
          </h1>
          
          {/* Subtitle - Stagger delay */}
          <p className={cx(s.heroSubtitle, s.animateSubtitle)}>
            {description || "No te limites a disfrutar del agua."}
          </p>
          
          {/* Buttons - Final stagger */}
          <div className={cx(s.buttonContainer, s.animateButtons)}>
            <Link to={buttonLink1} className={s.btnGradient}>
              <img src={searchIcon} className={s.btnIcon} alt="" />
              <span>{buttonLabel}</span>
            </Link>
            <Link to={buttonLink2} className={cx(s.btnGradient, s.btnSecondary)}>
              <img src={steeingIcon} className={s.btnIcon} alt="" />
              <span>{buttonLabel2}</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  locale: state.intl.locale
});

export default connect(mapState)(withStyles(s, cs)(NewsBox));
